export default "__VITE_ASSET__k0S6_UWj__"